import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-705a0cb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "enterpriseWechat" }

import {searchFormConfig} from "./config/search.config";
import {contentTableConfig} from "./config/content.config";
import {usePageSearch} from "@/hooks/userPageSearch";
import {toDay} from "@/utils/date-format";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "@/store";
import {reactive, ref} from "vue";
import PageModal from "@/components/PageModal.vue";
import {getListData} from "@/service/main/system";
import {usePageModal} from "@/hooks/usePageModal";
import {modalConfig} from "./config/modal.config";
import {initEmptyParam} from "@/hooks/useInitParam";


export default /*#__PURE__*/_defineComponent({
  __name: 'EnterpriseWechat',
  setup(__props) {

initEmptyParam()
let query = {}
const route = useRoute()
const store = useStore()
if (route.query['deptId']) {
  const depts = store.state.login.depts
  for (const dept of depts) {
    if (dept.id == route.query['deptId']) {
      const empIds = []
      for (const emp of dept.emps) {
        empIds.push(emp.id)
      }
      query = {empIds}
    }
  }
  query = {...query, createdTime: route.query.createdTime}
} else {
  query = {...route.query}
}

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find((item) => item.field === 'qyId')
  roleItem!.options = roleData.map((item: any) => {
    return {title: item.name, value: item.id}
  })
}

getCompanyList()

const getUserList = async () => {
  let userList = await getListData('/main/enterpriseWechat/dingUser/listAll', {});
  const userOptions = userList.map((item: any) => {
    return {title: item.userName, value: item.userName};
  })
  const userItem = searchFormConfig.formItems.find(item => item.field === 'usedBy');
  userItem!.options = userOptions;
  const modalUserItem = modalConfig.formItems.find(item => item.field === 'usedBy');
  modalUserItem!.options = userOptions;
}
getUserList();

const userInfo = store.state.login.userInfo

const getDept = async () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'usedByDept'
  )
  const deptData = await getListData('/main/enterpriseWechat/dingDept/listAll', {});
  dept!.options = deptData.map((item: any) => {
    return {title: item.deptName, value: item.deptName}
  })
}

getDept()

const pageInfo = ref({pageNo: 1, pageSize: 10})
const queryParam = {
  createdTime: [toDay(), toDay()],
  ...query,
  pageNo: pageInfo.value.pageNo,
  pageSize: pageInfo.value.pageSize
}
const resetCb = () => {
  return queryParam
}

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb);
const router = useRouter()


const modalTitle = ref('')

const newCb = () => {
}
const editCb = (item: any) => {
  modalTitle.value = item.userid;
}

let custCommPlanIds: Array<number> = []
let exploitAccounts: string
const handleSlectionChange = (value: any[]) => {
  custCommPlanIds = []
  exploitAccounts = ""
  for (const row of value) {
    custCommPlanIds.push(row.id)
    exploitAccounts += (row.exploitAccount + ", ")
  }
  exploitAccounts = exploitAccounts.substring(0, exploitAccounts.length - 2);
}

const refreshFunc = () => {
  store.dispatch('system/getPageListAction', {
    pageName: 'enterpriseWechat',
    queryInfo: queryParam
  })
}
const showViewer = ref(false)
const handleSortChange = (value: any) => {
  let orderBy = value.prop;
  if (orderBy) {
    orderBy = orderBy.replace('Desc', '')
  }
  store.commit('system/changeOrderInfo', {
    orderBy: orderBy,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const dialogTableVisible = ref(false)
const dialogVisible = ref(false)
const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const otherInfo = reactive({})

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "enterpriseWechat",
      onSelectionChange: handleSlectionChange,
      onSortChange: handleSortChange,
      onEditBtnClick: _unref(handleEditData),
      onDownBtnClick: _unref(handleDownBtnClick),
      downFilename: "企业微信对应数据.xlsx"
    }, null, 8, ["contentTableConfig", "onEditBtnClick", "onDownBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "enterpriseWechat",
      otherInfo: otherInfo
    }, null, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})